if (!customElements.get('collection-tabs')) {
  class CollectionTabs extends HTMLElement {
    constructor() {
      super();
    }

    handleClick(event) {
      event.preventDefault();

      if(!event.target.hasAttribute('href')) return;

      this.querySelectorAll('.is-active').forEach(element => {
        element.classList.remove('is-active');
      });

      event.target.classList.add('is-active');
      document.getElementById(event.target.getAttribute('href').replace('#', '')).classList.add('is-active');
    }

    connectedCallback() {
      this.head = this.querySelector('.js-tabs-head');
      this.head.addEventListener('click', this.handleClick.bind(this));
    }
  }
  customElements.define('collection-tabs', CollectionTabs);
}
